import { Box } from "arkh";
import React, { SetStateAction, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useSizeClass } from "../../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { WAFakeHeader } from "../../WidgetAdd/WAFakeHeader";
import {
  TeamSelectList,
  TeamSelectListWholeStoreOption,
} from "widgets/src/TeamSelectList";
import { WidgetEmployeeScheduleSettingsQuery_store$key } from "./__generated__/WidgetEmployeeScheduleSettingsQuery_store.graphql";
import { useNavigation } from "@react-navigation/native";
import { UserLoggedInNavigatorParamList } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";

import { useModalInsets } from "../../../../../components/mobile/useModalInsets";
import { ManageEmployeeSchedueTypesListItem } from "../ManageEmployeeSchedueTypesListItem";

type Props = {
  teamIds: string[];
  setTeamIds(_: SetStateAction<string[]>): void;
  store: WidgetEmployeeScheduleSettingsQuery_store$key;
};

export function WidgetEmployeeScheduleSettings(props: Props) {
  const navigation =
    useNavigation<NativeStackNavigationProp<UserLoggedInNavigatorParamList>>();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const store = useFragment(
    graphql`
      fragment WidgetEmployeeScheduleSettingsQuery_store on Store {
        myRole
        publicTeams {
          ...TeamSelectList_Team
        }
        ...ManageEmployeeSchedueTypesListItem_store
      }
    `,
    props.store
  );

  const setTeamIds = props.setTeamIds;
  const onItemPress = useCallback(
    (itemId: string, selected: boolean) => {
      if (selected) {
        setTeamIds((ids) => ids.filter((id) => id !== itemId));
      } else {
        setTeamIds((ids) => [...ids, itemId]);
      }
    },
    [setTeamIds]
  );

  const intl_tokens = useIntlTokens();
  const insets = useModalInsets();
  return (
    <Box style={{ flex: 1 }}>
      {!isCompact ? <WAFakeHeader title={intl_tokens.SelectTeams} /> : null}
      <TeamSelectList
        insets={insets}
        teams={store.publicTeams}
        selected={props.teamIds}
        ListHeaderComponent={
          <Box spaceTop="medium">
            {store.myRole === "ADMIN" ? (
              <>
                <ManageEmployeeSchedueTypesListItem
                  onPress={() => {
                    navigation.navigate("EmployeeScheduleEdit", {
                      screen: "EmployeeScheduleEditScheduleTypesScreen",
                      params: {},
                    });
                  }}
                  store={store}
                />
                <Box spaceTop="large" />
              </>
            ) : null}
            <TeamSelectListWholeStoreOption
              onSelect={() => props.setTeamIds([])}
              selected={props.teamIds.length === 0}
            />
          </Box>
        }
        onItemPress={onItemPress}
      />
    </Box>
  );
}
